export default "__VITE_ASSET__Cd6teI_E__"